// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"131":"6ef831ae75779770","319":"c97e26e097264bfe"}[chunkId] + ".js";
};